module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_vm._l((_vm.posts), function(post) {
    return _c('div', {
      key: post.id,
      staticClass: "post"
    }, [_c('h3', [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "category"
    }, [_vm._v(_vm._s(post.category.category))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(post.date))])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(post.content)
      }
    })])
  }), _vm._v(" "), (!_vm.hideMore) ? _c('button', {
    staticClass: "big-btn blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._v("\n        More ->\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.categories), function(cat) {
    return _c('li', {
      key: cat.id
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.catClick(cat)
        }
      }
    }, [_vm._v(_vm._s(cat.category))])])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "widget"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.archives), function(archive) {
    return _c('li', {
      key: archive.id
    }, [_c('a', {
      attrs: {
        "href": ";javascript"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.archiveClick(archive)
        }
      }
    }, [_vm._v(_vm._s(archive.month + " " + archive.year))])])
  }))])]), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "9157837875",
      "ad-style": "display:inline-block;width:160px;height:600px",
      "ad-format": "auto"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Categories")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Archives")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d9a3f1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Blog.vue
// module id = 487
// module chunks = 1